import { useEffect, useState } from 'react';
import { WhatsAppApi } from '../api/resources';

/** Total unread WhatsApp messages, polled while the panel is open. */
export default function useWhatsAppUnread(enabled) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;
    let dead = false;
    const pull = () =>
      WhatsAppApi.unreadCount()
        .then((n) => !dead && setCount(n))
        .catch(() => {});
    pull();
    const t = setInterval(pull, 15000);
    return () => {
      dead = true;
      clearInterval(t);
    };
  }, [enabled]);

  return count;
}
